import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  // Sample data - replace with real data from your API
  const partnerStats = [
    { name: 'Total Resellers', value: 24, icon: 'stacked_line_chart', trend: 'up' },
    { name: 'Active Partners', value: 18, icon: 'groups', trend: 'up' },
    { name: 'Pending Settlements', value: 5, icon: 'pending', trend: 'down' },
    { name: 'Revenue (This Month)', value: '$12,450', icon: 'attach_money', trend: 'up' }
  ];

  const recentActivities = [
    { id: 1, partner: 'ABC Corp', action: 'Project submission', time: '2 hours ago', status: 'pending' },
    { id: 2, partner: 'XYZ Ltd', action: 'Document upload', time: '5 hours ago', status: 'completed' },
    { id: 3, partner: 'Tech Solutions', action: 'Profile update', time: '1 day ago', status: 'completed' },
    { id: 4, partner: 'Global Partners', action: 'New partnership request', time: '2 days ago', status: 'pending' }
  ];

  return (
    <main className="main-content">
      <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
        <h2 className="text-xl font-semibold text-gray-800">
          Partner Dashboard
        </h2>

        <nav>
          <ol className="flex items-center gap-1.5 mr-7">
            <li>
              <Link
                className="inline-flex items-center gap-1.5 text-sm text-black"
                to="/dashboard"
              >
                Home /
              </Link>
            </li>
            <li className="text-sm text-gray-800">
              Dashboard
            </li>
          </ol>
        </nav>
      </div>

      <div className="mx-auto p-4 md:p-4">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
          {partnerStats.map((stat, index) => (
            <div key={index} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">{stat.name}</p>
                  <p className="text-2xl font-semibold text-gray-800 mt-1">{stat.value}</p>
                </div>
                <span className="material-symbols-outlined text-3xl text-[#635BFF]">
                  {stat.icon}
                </span>
              </div>
              <div className={`mt-2 text-sm ${stat.trend === 'up' ? 'text-green-500' : 'text-red-500'}`}>
                {stat.trend === 'up' ? '↑ 12% from last month' : '↓ 5% from last month'}
              </div>
            </div>
          ))}
        </div>

        {/* Recent Activities */}
        <div className="rounded-2xl border border-gray-200 bg-white mb-6">
          <div className="px-5 py-4 sm:px-6 sm:py-5 border-b border-gray-100">
            <h3 className="text-base font-medium text-gray-800">
              Recent Activities
            </h3>
          </div>
          <div className="p-2 sm:p-5">
            <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
              <div className="max-w-full overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="text-white border-b border-gray-100 whitespace-nowrap" style={{ backgroundColor: "#635BFF" }}>
                      <th className="px-3 py-2 sm:px-5 sm:py-3 text-left text-xs sm:text-sm font-medium">Partner</th>
                      <th className="px-3 py-2 sm:px-5 sm:py-3 text-left text-xs sm:text-sm font-medium">Action</th>
                      <th className="px-3 py-2 sm:px-5 sm:py-3 text-left text-xs sm:text-sm font-medium">Time</th>
                      <th className="px-3 py-2 sm:px-5 sm:py-3 text-left text-xs sm:text-sm font-medium">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {recentActivities.map((activity) => (
                      <tr key={activity.id} className="whitespace-nowrap hover:bg-gray-50">
                        <td className="px-3 py-2 sm:px-5 sm:py-4 text-sm text-gray-800">{activity.partner}</td>
                        <td className="px-3 py-2 sm:px-5 sm:py-4 text-sm text-gray-800">{activity.action}</td>
                        <td className="px-3 py-2 sm:px-5 sm:py-4 text-sm text-gray-800">{activity.time}</td>
                        <td className="px-3 py-2 sm:px-5 sm:py-4">
                          <span className={`px-2 py-1 text-xs rounded-full flex items-center gap-1 ${
                            activity.status === 'completed' 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            <span className="material-symbols-outlined text-sm">
                              {activity.status === 'completed' ? 'check_circle' : 'pending'}
                            </span>
                            {activity.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="rounded-2xl border border-gray-200 bg-white">
          <div className="px-5 py-4 sm:px-6 sm:py-5 border-b border-gray-100">
            <h3 className="text-base font-medium text-gray-800">
              Quick Actions
            </h3>
          </div>
          <div className="p-5 grid grid-cols-2 sm:grid-cols-4 gap-4">
            <Link 
              to="#" 
              className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
            >
              <div className="bg-[#635BFF] text-white p-3 rounded-full mb-2">
                <span className="material-symbols-outlined">person_add</span>
              </div>
              <span className="text-sm font-medium text-gray-700">Add Partner</span>
            </Link>
            <Link 
              to="#" 
              className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
            >
              <div className="bg-[#635BFF] text-white p-3 rounded-full mb-2">
                <span className="material-symbols-outlined">folder_open</span>
              </div>
              <span className="text-sm font-medium text-gray-700">View Projects</span>
            </Link>
            <Link 
              to="#" 
              className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
            >
              <div className="bg-[#635BFF] text-white p-3 rounded-full mb-2">
                <span className="material-symbols-outlined">approval</span>
              </div>
              <span className="text-sm font-medium text-gray-700">Pending Approvals</span>
            </Link>
            <Link 
              to="#" 
              className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
            >
              <div className="bg-[#635BFF] text-white p-3 rounded-full mb-2">
                <span className="material-symbols-outlined">summarize</span>
              </div>
              <span className="text-sm font-medium text-gray-700">Generate Reports</span>
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;